import { render, staticRenderFns } from "./ShortcutView.vue?vue&type=template&id=3d3ba024&scoped=true"
import script from "./ShortcutView.vue?vue&type=script&lang=js"
export * from "./ShortcutView.vue?vue&type=script&lang=js"
import style0 from "./ShortcutView.vue?vue&type=style&index=0&id=3d3ba024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ba024",
  null
  
)

export default component.exports